/**
 * 权限配置处理
 * @author zjs
 * @time 2018-01-05
 */
export default {
    data () {
        return {
            formConfig: [{
                name: "权限名称",
                type: "ElInput",
                field: "name"
            }, {
                name: "备注",
                type: "ElInput",
                field: "remark"
            }]
        }
    }
}